import ExcludeByStaticListsFilter from "../../components/filters/ExcludeByStaticListsFilter/ExcludeByStaticListsFilter";
import ExcludeByStaticListsFilterResult from "../../components/filters/ExcludeByStaticListsFilter/ExcludeByStaticListsFilterResult";
import { leadsCapabilityMap } from "../../types/leadsCapability";
import { leadsFilterApiCategory } from "../../types/leadsFilterApiCategory";
import { leadsFilterCategoryMap } from "../../types/leadsFilterCategory";
import { defineLeadsFilter } from "../defineLeadsFilter";

import FindExcludeByStaticListsFilter from "./ExcludeByStaticListsFilter";

export const staticListsToExcludeDefinition = defineLeadsFilter({
    key: "staticListsToExclude",
    apiCategory: leadsFilterApiCategory.staticListsToExclude,
    category: leadsFilterCategoryMap.exclude,
    trackingName: "Exclude websites from statics lists",
    titleKey: { key: "si.lead_gen_filters.staticListsToExclude.name" },
    requiresCapabilities: [leadsCapabilityMap.excludeFilters],

    render: ({ opportunityLists }) => ({
        filter: new FindExcludeByStaticListsFilter({
            options: opportunityLists,
        }),
        filterView: ExcludeByStaticListsFilter,
        filterResultView: ExcludeByStaticListsFilterResult,
    }),
});
